export class OpenDocumentEvent extends CustomEvent {
    constructor(detail) {
        super("patchwork:open-document", {
            detail,
            composed: true,
            bubbles: true,
        });
    }
}
export class MountedEvent extends CustomEvent {
    constructor(detail) {
        super("patchwork:mounted", {
            detail,
            composed: true,
            bubbles: true,
        });
    }
}
export class NoToolEvent extends CustomEvent {
    constructor(detail) {
        super("patchwork:no-tool", {
            detail,
            composed: true,
            bubbles: true,
        });
    }
}
export const openDocument = (element, url, toolId) => {
    element.dispatchEvent(new OpenDocumentEvent({ url, toolId }));
};
